import { msalInstance } from '../config/authConfig';
import { AdminMetricsService } from './admin/metrics';
import { AdminSiteService } from './admin/site';
import { AdminTeamService } from './admin/team';
import { AdminUserService } from './admin/user';
import { API } from './api';
import { ConfiguratorService } from './configurator';
import { CustomerService } from './customer';
import { DocumentService } from './document';
import { OperationAttachmentService } from './operation-attachment';
import { QuoteService } from './quote';
import { UserService } from './user';

const api = new API({ msalInstance });

export const userService = new UserService(api);
export const customerService = new CustomerService(api);
export const documentService = new DocumentService(api);
export const quoteService = new QuoteService(api);
export const configuratorService = new ConfiguratorService(api);
export const operationAttachmentService = new OperationAttachmentService(api);

export const adminSiteService = new AdminSiteService(api);
export const adminTeamService = new AdminTeamService(api);

export const adminUserService = new AdminUserService(api);
export const adminMetricsService = new AdminMetricsService(api);
